import Logo from '../src/Logo.png';
import './App.css';
import 'linearicons/dist/web-font/style.css';

import Route from '../src/Router/Route';
import { useEffect } from 'react';
import { get } from './ApiServices/ApiServices';
import { useNavigate } from 'react-router-dom';

function App() {

  // 🔥 Auto reload when new build is deployed
  useEffect(() => {
    const interval = setInterval(() => {
      fetch("/version.json", { cache: "no-store" })
        .then(res => res.json())
        .then(data => {
          const localVersion = localStorage.getItem("appVersion");

          if (localVersion && localVersion !== data.version) {
            window.location.reload(); // auto reload
          }

          localStorage.setItem("appVersion", data.version);
        })
        .catch(() => { });
    }, 60000); // 1 minute

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Route />
    </>
  );
}

export default App;
